import NotificationList from "../../components/notifications/NotificationList";

import "./Notifications.css";

function Notifications() {

    return (

        <div className="notifications-page">

            <div className="notifications-header">

                <div>

                    <h1>

                        Notifications

                    </h1>

                    <p>

                        Stay updated with your latest activities.

                    </p>

                </div>

            </div>

            <NotificationList />

        </div>

    );

}

export default Notifications;